import {createRouter, createWebHistory} from 'vue-router'
import dashboard from './routes/dashboard'
import auth from './routes/auth'
import common from './routes/common'
import profile from './routes/profile'
import company from './routes/company'
import journal from './routes/journal'
import receipt from './routes/receipt'
import contra from './routes/contra'
import payment from './routes/payment'
import hospital from './routes/hospital'
import chartAccount from './routes/chartAccount'
import other from './routes/other'
import accountSettings from './routes/accountSettings'
import report from './routes/report'
import proadvisor from './routes/proadvisor'
import inventory from './routes/inventory'
import companySettings from './routes/companySettings'
import contact from "@/router/routes/contact";
import deal from "@/router/routes/deal";
import campaign from "@/router/routes/campaign";
import business from "@/router/routes/business";
import user from "@/router/routes/user";
import role from "@/router/routes/role";
import procurementInventory from "@/router/routes/procurement/inventory";
import procurementFd6 from "@/router/routes/procurement/fd6";
import procurementProject from "@/router/routes/procurement/project";
import procurementBudget from "@/router/routes/procurement/budget";
import procurementActivity from "@/router/routes/procurement/activity";
import procurementRequisition from "@/router/routes/procurement/requisition";
import procurementVendorSelection from "@/router/routes/procurement/vendorSelection";
import procurementPurchaseOrder from "@/router/routes/procurement/purchaseOrder";
import procurementImportTracker from "@/router/routes/procurement/importTracker";
import procurementOrganizationSettings from "@/router/routes/procurement/organizationSettings";
import ngoPaymentVoucher from "@/router/routes/ngo/payment";
import datasheetExport from "@/router/routes/procurement/datasheet";
import npJournalVoucher from "@/router/routes/ngo/journal";
import npReceiptVoucher from "@/router/routes/ngo/receipt"
import npContraVoucher from "@/router/routes/ngo/contra";
import voucher from "@/router/routes/voucher";
import tdsVds from "@/router/routes/procurement/tdsVds";
import scmTagRegister from "@/router/routes/scm/tag-register";
import scmLandedCosting from "@/router/routes/scm/landed-costing";
import crm from "@/router/routes/crm/crm";
import accounting from "@/router/routes/accounting/accounting";
import compliance from "@/router/routes/compliance/compliance";
import hrPayroll from "@/router/routes/hrPayroll/hrPayroll";
import sdm from "@/router/routes/sdm/sdm";
import assetRegister from "@/router/routes/assetRegister/assetRegister";
import career from "@/router/routes/career";
import admin from './routes/admin/admin';
import store from "@/store";

const routes = [
	...dashboard,
	...auth,
	...common,
	...profile,
	...contact,
	...deal,
	...campaign,
	...company,
	...other,
	...contra,
	...receipt,
	...journal,
	...payment,
	...hospital,
	...voucher,
	...proadvisor,
	...inventory,
	...chartAccount,
	...accountSettings,
	...companySettings,
	...report,
	...user,
	...role,
	...business,
	...procurementInventory,
	...procurementFd6,
	...procurementProject,
	...procurementBudget,
	...procurementActivity,
	...procurementRequisition,
	...procurementVendorSelection,
	...procurementPurchaseOrder,
	...procurementImportTracker,
	...procurementOrganizationSettings,
	...ngoPaymentVoucher,
	...datasheetExport,
	...npJournalVoucher,
	...npReceiptVoucher,
	...npContraVoucher,
	...tdsVds,
	...scmTagRegister,
	...scmLandedCosting,
	...crm,
	...accounting,
	...compliance,
	...hrPayroll,
	...sdm,
	...assetRegister,
	...admin,
	...career,
	{
		path: '/:pathMatch(.*)*',
		redirect: 'error-404',
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),

	routes,

	scrollBehavior(to, from, savedPosition) {

		if (savedPosition) {
			return savedPosition;
		} else if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth'
			}
		} else {
			return new Promise((resolve) => {
				setTimeout(() => resolve({top: 0, behavior: 'smooth'}), 500)
			})
		}
	},
});

router.beforeEach(async (to, from, next) => {
	window.document.title = to.meta && to.meta.title ? to.meta.title : 'miaccounts';

	if (to.matched.some(record => record.meta.requiresAuth)) {
	 	const token = localStorage.getItem('token');
		const publicToken = localStorage.getItem('X-Public-Token');

		if (!token && !publicToken) {
			next('/login')
			return
		}

		next();

	} else {
		next()
	}
});

router.afterEach(async (to) => {
	const { companyId, moduleId } = to.params;
	const query = { company_id: companyId ?? null };

	const unAuthorizedRoutes = await store.dispatch("routeAuthorization/getAuthorizedRoutes", query);
	const isRouteAuthorized = !companyId || !unAuthorizedRoutes.includes(to.name);

	if (! isRouteAuthorized) {
		router.push({name: 'Company', params: { companyId, moduleId } });
	}
});

export default router
